  <template>
  <element class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '资金总览'}]"/>
    <el-row :gutter="10">
      <el-col :span="11">
        <el-card class="box-card box-card-hbg box-card-htc">
          <div slot="header" class="clearfix">
            <span>放款</span>
          </div>
          <div class="daikuan-body">
            <div class="text-title-spec">
              今日放款累计
              <p>{{reportingStatisticsValues.PaymentToday|formatMoney}} 元</p>
            </div>
            <el-col :span="8">
              <div class="daikuan-text">
                当日自动放款笔数<br><span>{{reportingStatisticsValues.PaymentCountTodayA}}</span>笔
              </div>
              <div class="daikuan-line2"></div>
              <div class="daikuan-text">
                当日自动放款金额<br><span>{{reportingStatisticsValues.PaymentTodayA|formatMoney}}元</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="daikuan-text">
                当日人工放款笔数<br><span>{{reportingStatisticsValues.PaymentCountTodayM}}</span>笔
              </div>
              <div class="daikuan-line2"></div>
              <div class="daikuan-text">
                当日人工放款金额<br><span>{{reportingStatisticsValues.PaymentTodayM|formatMoney}}元</span>
              </div>
            </el-col>
            <el-col :span="8" class="">
              <div class="daikuan-text bg-danger">
                当日放款异常笔数<br><span>0</span>笔
              </div>
              <div class="daikuan-danger-line2"></div>
              <div class="daikuan-text bg-danger">
                当日放款异常金额<br><span>0.00元</span>
              </div>
            </el-col>
            <div class="cb"></div>
            <div class="daikuan-line"></div>
            <div class="text-title-spec">
              最近6个月放款累计
              <p>{{reportingStatisticsValues.PaymentSixMonths|formatMoney}} 元</p>
            </div>
            <el-col :span="12">
              <div class="daikuan-text">
                最近6个月放款累计笔数<br><span>{{reportingStatisticsValues.PaymentCountTodayA}}</span>笔
              </div>
              <div class="daikuan-line2"></div>
              <div class="daikuan-text">
                自动放款累计金额<br><span>{{reportingStatisticsValues.PaymentSixMonthsA|formatMoney}}元</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="daikuan-text">
                人工放款累计笔数<br><span>{{reportingStatisticsValues.PaymentCountSixMonthsM}}</span>笔
              </div>
              <div class="daikuan-line2"></div>
              <div class="daikuan-text">
                人工放款累计金额<br><span>{{reportingStatisticsValues.PaymentSixMonthsM|formatMoney}}元</span>
              </div>
            </el-col>
          </div>
        </el-card>
      </el-col>
      <el-col :span="13">
        <el-card class="box-card box-card-hbg box-card-htc">
          <div slot="header" class="clearfix">
            <span>还款</span>
          </div>
          <div class="daikuan-body">
            <div>今日还款金额</div>
            <div class="chart01">
              <ve-ring :data="chartDataToday"></ve-ring>
            </div>
            <div class="cb"></div>
            <div class="daikuan-line"></div>
            <div>最近六个月还款金额</div>
            <div class="chart02">
              <ve-ring :data="chartDataSixMonths"></ve-ring>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import xhr from '../../../utils/xhr'

  export default {
    name: "FinanceIndex",
    data() {
      return {
        options: [
          //放款 A:自动，M：人工
          'PaymentCountSixMonths',
          'PaymentCountSixMonthsA',
          'PaymentCountSixMonthsM',
          'PaymentCountToday',
          'PaymentCountTodayA',
          'PaymentCountTodayM',
          'PaymentSixMonths',
          'PaymentSixMonthsA',
          'PaymentSixMonthsM',
          'PaymentToday',
          'PaymentTodayA',
          'PaymentTodayM',

          //还款 A:第三方在线支付，M：转账
          'RepaymentCountSixMonths',
          'RepaymentCountSixMonthsA',
          'RepaymentCountSixMonthsB',
          'RepaymentCountSixMonthsM',
          'RepaymentCountToday',
          'RepaymentCountTodayA',
          'RepaymentCountTodayB',
          'RepaymentCountTodayM',
          'RepaymentSixMonths',
          'RepaymentSixMonthsA',
          'RepaymentSixMonthsM',
          'RepaymentToday',
          'RepaymentTodayA',
          'RepaymentTodayM',
        ],
        reportingStatisticsValues: {},
      }
    },
    mounted() {
      this.getReportingStatisticsValues(this.options.join(','))
    },
    computed: {
      chartDataToday: {
        get: function () {
          return {
            columns: ['还款方式', '金额'],
            rows: [
              { '还款方式': '第三方在线支付', '金额': this.reportingStatisticsValues.RepaymentTodayA },
              { '还款方式': '转账', '金额': this.reportingStatisticsValues.RepaymentTodayB },
              { '还款方式': '线下', '金额': this.reportingStatisticsValues.RepaymentTodayM },
            ]
          }
        }
      },
      chartDataSixMonths: {
        get: function () {
          return {
            columns: ['还款方式', '金额'],
            rows: [
              { '还款方式': '第三方在线支付', '金额': this.reportingStatisticsValues.RepaymentSixMonthsA },
              { '还款方式': '转账', '金额': this.reportingStatisticsValues.RepaymentSixMonthsB },
              { '还款方式': '线下', '金额': this.reportingStatisticsValues.RepaymentTodayM },
            ]
          }
        }
      }
    },
    methods: {
      getReportingStatisticsValues: function(options) {
        let that=this
        xhr.getReportingStatistics({
          options
        }, res=>{
          that.reportingStatisticsValues = res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinanceIndex.vue